import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getPosConfigurations: EvokeAction<AppState, AppActions> = async store => {
  try {
    const posConfigurations = await api.get(`pos-configurations`);
    
    await store.update(state => {
      state.posConfigurations = posConfigurations;
    });
  } catch (error) {
    console.log("error...", error);
  }
};

const createPosConfiguration: EvokeAction<AppState, AppActions> = async (
  store,
  values: Array<object>
) => {
  try {
    await api.post(
      `pos-configurations`,
      {},
      values
    );

    // await store.update((state) => {
    //   if (state.posConfigurations !== undefined) {
    //     state.posConfigurations[posConfigurations.config_id] = posConfigurations;
    //   }
    // });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
const updatePosConfiguration: EvokeAction<AppState, AppActions> = async (
  store,
  id:number,
  values: Array<object>
) => {
  try {
    await api.patch(
      `pos-configurations/${id}`,
      {},
      values
    );

    // await store.update((state) => {
    //   if (state.posConfigurations !== undefined) {
    //     state.posConfigurations[posConfigurations.id] = posConfigurations;
    //   }
    // });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const configurationActions = {
    getPosConfigurations,
    createPosConfiguration,
    updatePosConfiguration
};